import { ComboBoxRange, DateRange, FilterFields, NumberRange } from "..";

export const buildFilterObject = (
    filters: Record<string, string>,
): Record<string, Record<string, string[]>> => {
    const filterObj: Record<string, Record<string, string[]>> = {};

    Object.entries(filters).forEach(([key, value]) => {
        if (value) {
            if (FilterFields.date.includes(key)) {
                const dateRange: DateRange = JSON.parse(value);
                if (dateRange.min !== null || dateRange.max !== null) {
                    filterObj[key] = {};

                    if (dateRange.min !== null) {
                        filterObj[key].gte = [String(dateRange.min)];
                    }
                    if (dateRange.max !== null) {
                        filterObj[key].lte = [String(dateRange.max)];
                    }
                }
            } else if (FilterFields.number.includes(key)) {
                const range: NumberRange = JSON.parse(value);
                if (range.min !== null || range.max !== null) {
                    filterObj[key] = {};
                    if (range.min !== null) {
                        filterObj[key].gt = [String(range.min)];
                    }
                    if (range.max !== null) {
                        filterObj[key].lt = [String(range.max)];
                    }
                }
            } else if (FilterFields.boolean.includes(key)) {
                filterObj[key] = { eq: [value] };
            } else if (FilterFields.comboBox.includes(key)) {
                const comboBoxValue: ComboBoxRange = JSON.parse(value);
                if (comboBoxValue.id) {
                    const firstKey = `${key.split(".")[0]}.id`;
                    filterObj[firstKey] = { eq: [comboBoxValue.id] };
                }
                if (comboBoxValue.value) {
                    filterObj[key] = { contains: [comboBoxValue.value] };
                }
            } else if (FilterFields.arrayFilter.includes(key)) {
                filterObj[key] = { array_contains: [value] };
            } else {
                filterObj[key] = { contains: [value] };
            }
        }
    });
    return filterObj;
};
